import { WORKSHOP_INSTITUTIONS } from '../../data/mock';

export default function CredibilityStrip() {
  return (
    <section className="bg-charcoal-deep text-ivory py-10 lg:py-14">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
        <div className="lg:col-span-4">
          <p className="text-[10px] tracking-[0.3em] uppercase text-champagne mb-3">Trusted By Professionals Across</p>
          <p className="font-serif text-xl lg:text-2xl text-ivory leading-snug">
            Educational institutions &amp; <em className="italic-accent">professional communities.</em>
          </p>
        </div>
        <div className="lg:col-span-8">
          <div className="flex flex-wrap items-center gap-x-10 gap-y-4">
            {WORKSHOP_INSTITUTIONS.map((w) => (
              <div key={w.name} className="flex items-center gap-3">
                <span className="h-1 w-1 rounded-full bg-champagne" />
                <span className="font-display text-base lg:text-lg tracking-[0.18em] uppercase text-ivory/90">{w.name}</span>
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs lg:text-sm text-ivory/55 leading-relaxed max-w-2xl">
            14+ years of industry experience in menswear, styling &amp; image strategy.
          </p>
        </div>
      </div>
    </section>
  );
}
